'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Grouping(id, created, account, kind, name, description) {
  this.n2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.L0 = null;
  this.E7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.tU = null;
  this.qf = null;
  this.tT = null;
  this.n2 = id;
  this.L0 = created;
  this.E7 = account;
  this.tU = kind;
  this.qf = name;
  this.tT = description;
}
export { $c_Lpresto_types$Grouping as $c_Lpresto_types$Grouping };
$p = $c_Lpresto_types$Grouping.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Grouping;
/** @constructor */
function $h_Lpresto_types$Grouping() {
}
export { $h_Lpresto_types$Grouping as $h_Lpresto_types$Grouping };
$h_Lpresto_types$Grouping.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Grouping"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.n2;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.L0));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.E7;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tU));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qf));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tT));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Grouping)) {
    var this$1 = this.n2;
    var b = x$0.n2;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.L0;
      var x$2 = x$0.L0;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var this$2 = this.E7;
      var b$1 = x$0.E7;
      var $x_2 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.tU;
      var x$4 = x$0.tU;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.qf === x$0.qf))) {
      return (this.tT === x$0.tT);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "Grouping";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.n2;
      break;
    }
    case 1: {
      return this.L0;
      break;
    }
    case 2: {
      return this.E7;
      break;
    }
    case 3: {
      return this.tU;
      break;
    }
    case 4: {
      return this.qf;
      break;
    }
    case 5: {
      return this.tT;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.jW = (function() {
  return this.n2;
});
function $isArrayOf_Lpresto_types$Grouping(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
export { $isArrayOf_Lpresto_types$Grouping as $isArrayOf_Lpresto_types$Grouping };
var $d_Lpresto_types$Grouping = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Grouping, "presto.types$Grouping", ({
  jU: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Grouping as $d_Lpresto_types$Grouping };
//# sourceMappingURL=presto.types$-Grouping.js.map
